<template>
  <v-container id="contact-grid" grid-list-xl>
    <section class="ftco-section">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-8">
          <div class="d-md-flex">
            <v-card class="px-4">
              <v-card-title class="w-100 card-title">
                {{ $t("askemail_title") }}
              </v-card-title>
              <v-card-title class="card-title justify-center">
                <div
                  v-if="errors['connexion']"
                  class="text-danger text-sm-body-2"
                >
                  <span>{{ errors["connexion"][langLocal] }}</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-snackbar
                  v-model="snackbar"
                  :color="snackbarColor"
                  :timeout="4000"
                  :top="true"
                  style="z-index: 1500"
                >
                  {{ snackbar_text }}
                </v-snackbar>
                <v-form class="m-5">
                  <v-row>
                    <v-text-field
                      :error-messages="emailErrors"
                      required
                      @blur="$v.email.$touch()"
                      prepend-icon="email"
                      v-model="email"
                      name="email"
                      label="Email"
                      type="email"
                    ></v-text-field>
                    <v-btn
                      class="mx-2 my-2"
                      color="warning"
                      @click="submit"
                      :loading="isLoading"
                      :disabled="this.$v.$invalid"
                    >
                      {{ $t("save_btn") }}
                    </v-btn>
                  </v-row>
                  <!-- <div class="g-recaptcha" data-sitekey="6LcePAATAAAAAGPRWgx90814DTjgt5sXnNbV5WaW"></div> -->
                </v-form>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </section>
  </v-container>
</template>

<script>
import img from "../../public/african.jpeg";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "Register",
  mixins: [validationMixin],
  validations: {
    email: { required, email },
  },
  created() {
    this.$root.$i18n.locale = this.langLocal;
  },
  mounted(){
     let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?hl=fr')
      document.head.appendChild(recaptchaScript)
  },
  data() {
    return {
      snackbar: false,
      snackbarColor: "default",
      snackbar_text: "",
      email: null,
      isLoading: false,
      show1: false,
      img_log: img,
    };
  },

  watch: {},
  methods: {
    async submit() {
      this.isLoading = true;
      this.$v.$touch();
      const data = new FormData();
      data.append("email", this.email);
      if (!this.$v.$invalid) {
        await this.$store
          .dispatch("checkMail", data)
          .then((response) => {
            this.isLoading = false;

            if (response.data == "Not found") {
              this.snackbar = true;
              this.snackbarColor = "red";
              this.snackbar_text = this.getLocaleMessages["checkmail_failed"];
            } else {
              this.snackbar = true;
              this.snackbarColor = "green";
              this.snackbar_text = this.getLocaleMessages["checkmail_success"];

              // let data = {
              //   email: this.email,
              // }
              // this.$router
              //   .push({
              //     name: 'ResetPassword',
              //     params: { data },
              //   })
              //   .catch(() => {})
            }
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error);
          });
      }
    },
  },
  beforeCreate() {
    this.isLoading = false;
    this.$store.dispatch("clear");
  },
  computed: {
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.$root.$i18n.locale];
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(this.getLocaleMessages["valid_email"]);
      !this.$v.email.required &&
        errors.push(this.getLocaleMessages["required_email"]);
      return errors;
    },

    ...mapGetters(["registered", "loading", "errors", "langLocal"]),
  },
};
</script>

<style scoped>
@import "../../public/assets/css/style.css";


#contact-grid {
  width: 100%;
}
#img-block {
  background-image: url("../../public/african.jpeg");
}
.mobile-position {
  margin: 10px;
}
.card-title {
  color: rgb(63, 53, 99);
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.w3l-footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 100;
  width: 100%;
}

@media (max-width: 700px) {
  #img-block {
    display: none;
  }
  .login-wrap {
    min-height: 60vh;
  }
}
</style>
